import './AboutMe.css'



function AboutMe() {



    return (
        <div className='about-me'>
            <p className='letters-head-section'>Sobre mí</p>
            <div className='container-me'>
                <section className='section-me'>
                    <div className='container-section-me'>
                        <p className='section-me-text'>
                            Mi nombre es Francisco José López Laperal, soy de Sanxenxo y Desarrollador Junior Full Stack.
                            Mi formación hasta ahora se ha centrado en el ámbito de la actividad física y el deporte,
                            pero he decidido cambiar de rumbo y adentrarme en el mundo del Desarrollo Web. Me he formado
                            en diversas tecnologías a través de un Bootcamp y cursos basados en las tecnologías que he
                            aprendido así como otras que creo son muy interesantes para mi desarrollo.
                        </p>
                        <p className='section-me-text'>
                            Durante mi formación, fui expuesto a proyectos intensivos y colaborativos que me permitieron
                            desarrollar una comprensión profunda de las mejores prácticas de programación y una experiencia
                            práctica en el desarrollo de aplicaciones web utilizando JavaScript y el framework React.
                            A través de estos proyectos, aprendí a construir interfaces de usuario interactivas, gestionar
                            el estado de la aplicación y trabajar con API para crear experiencias de usuario fluidas y
                            eficientes.
                        </p>
                        <p className='section-me-text'>
                            Mi pasión por la programación se ha convertido en un motor que impulsa mi constante aprendizaje
                            y mejora. Estoy emocionado de aplicar mis habilidades técnicas y mi capacidad para resolver
                            problemas en un entorno laboral real. Me enorgullece trabajar en equipo y disfruto
                            contribuyendo con ideas y soluciones creativas para superar desafíos complejos.
                        </p>
                        <p className='section-me-text'>
                            Además de mis habilidades técnicas, he desarrollado una mentalidad de crecimiento y una
                            habilidad para adaptarme rápidamente a nuevas tecnologías y entornos de trabajo. Dentro
                            de mi balanza personal siempre tendrá más peso el poder seguir aprendiendo de forma continua
                            y enfrentarme a nuevos desafíos para crecer profesionalmente.
                        </p>
                    </div>

                </section>
            </div>


        </div>
    )
}

export default AboutMe